import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-machine-mode-conflict',
  templateUrl: './machine-mode-conflict.component.html',
  styleUrls: ['./machine-mode-conflict.component.scss'],
})
export class MachineModeConflictComponent implements OnInit {
  @Input() data: any;
  public newModes: any[] = [];
  public currentModes: any[] = [];

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    const response = this.data;
    this.newModes = response?.response?.newModes ?? [];
    this.currentModes = response?.response?.currentModes ?? [];
  }

/**
 * Closes modal
 */
public closeModal() {
    this.modalController.dismiss({ action: 'close' });
  }

  /**
   * Confirms removal of conflicting modes
   */
  public import() {
    this.modalController.dismiss({ action: 'import' });
  }
}
